import { render, staticRenderFns } from "./ResultDetailOutputOutRight.vue?vue&type=template&id=50217dfc&scoped=true&"
import script from "./ResultDetailOutputOutRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailOutputOutRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50217dfc",
  null
  
)

export default component.exports